import React from 'react';

import { action, observable } from 'mobx';
import { observer } from 'mobx-react';

import createContext from 'bz-utilities/hooks/context-v2';

export const [DialogStoreContext, useDialogStore] = createContext<DialogStore>('DialogStore');

export interface IProps extends React.PropsWithChildren {}

export const DialogStoreProvider: React.FC<IProps> = observer(({ children }) => {
  const [store] = React.useState(() => {
    return new DialogStore();
  });

  return <DialogStoreContext.Provider value={store}>{children}</DialogStoreContext.Provider>;
});

class DialogStore {
  @observable isOpen: boolean = false;

  @action.bound
  public open(): void {
    this._open();
  }

  @action.bound
  public close(): void {
    this._close();
  }

  @action.bound
  protected _open(): void {
    this.isOpen = true;
  }

  @action.bound
  protected _close(): void {
    this.isOpen = false;
  }
}

export default DialogStore;
